import { render, staticRenderFns } from "./PasoCinco.vue?vue&type=template&id=1d51655c"
import script from "./PasoCinco.vue?vue&type=script&lang=js"
export * from "./PasoCinco.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports